import { functions, httpsCallable } from 'services/firebase';
import type { HttpsCallableResult, UpdateProfileResponse, Profile } from 'types';

export function updateProfile(
  profile: Profile
): Promise<HttpsCallableResult<UpdateProfileResponse>> {
  const updateProfile = httpsCallable<Profile, UpdateProfileResponse>(functions, 'updateProfile');
  return updateProfile(profile);
}
